export enum ServiceTypes{
    NoLanguage = 1,
    Monolingual = 2,
    Bilingual = 3
}